import { z } from 'zod';

import { EscrowPaymentHistoryItemId, LosId, PaymentId, QcDocumentId } from '../../BrandedIds';
import { Actor } from '../../events/BaseLoanEvent';
import { EscrowPaymentHistoryItemStatus } from '../../loan/EscrowPaymentHistoryItem';
import { zodTemporalInstant, zodTemporalPlainDate } from '../../Temporal';

export const ExportableEscrowPaymentHistoryItem = z
  .object({
    id: EscrowPaymentHistoryItemId,
    loanId: LosId,
    ordinal: z
      .int()
      .optional()
      .describe("Position of this entry in the loan's escrow-payment history. Order is authoritative where dates tie."),

    type: z.enum(['initial', 'manualUpdate', 'api', 'csv', 'shortagePayment', 'analysis', 'constructionToPermanent']),
    createdAt: zodTemporalInstant,
    newMonthlyAmount: z.number(),
    actor: Actor,
    status: EscrowPaymentHistoryItemStatus.optional(),

    effectiveDate: zodTemporalPlainDate.optional(),
    escrowShortageAnalysisId: EscrowPaymentHistoryItemId.optional(),
    paymentId: PaymentId.optional(),
    shortageAmount: z.number().optional(),
    newMonthlyAmountIfShortagePaidUpfront: z.number().optional(),
    qcDocumentId: QcDocumentId.optional(),
  })
  .meta({ title: 'EscrowPaymentHistoryItem' });

export type ExportableEscrowPaymentHistoryItem = z.infer<typeof ExportableEscrowPaymentHistoryItem>;
